import React from 'react';
import { cn } from '@/lib/utils';
import { getThemeById } from '@/data/heroThemes';

interface ThemeBackgroundProps {
  themeId: string | null | undefined;
  className?: string;
}

export const ThemeBackground: React.FC<ThemeBackgroundProps> = ({
  themeId,
  className,
}) => {
  const theme = getThemeById(themeId);
  
  return (
    <div className={cn('relative overflow-hidden', className)}>
      {/* Background image - key forces remount when theme changes */}
      <img
        key={theme.imageUrl}
        src={theme.imageUrl}
        alt=""
        aria-hidden="true"
        className="w-full h-full object-cover"
      />
      
      {/* Overlay for text readability */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: theme.overlayColor }}
      />
      
      {/* Bottom gradient fade for content transition */}
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </div>
  );
};
